/**
 * Story Feed
 * -----------------------------------------------------------------------------
 *
 * A horizontal slider with a maximum of six RSS feed items as members of the
 * slider as individual slides. On desktop, four items are displayed initially,
 * then a single item on smaller viewports.
 *
 * The feed comes in two versions, RSS and Picker. Of which, neither version
 * affects the implementation JS here, but useful to be mentioned here.
 */

// Imports
const $              = require( 'jquery' );
const throttle       = require( '../vendor/throttle/_throttle' );
const { MediaQuery } = require( '../utilities/_media-query' );
const {
  BREAKPOINT_SM,
  BREAKPOINT_MD,
  BREAKPOINT_LG
} = require( '../utilities/_constants' );



/**
 * Notes
 * 1. Converting jQuery collection of elements to an array of jQuery objects
 *    (from those elements).
 */
function StoryFeedSlider() {

  const NAMESPACE   = '.und.story-feed';
  const $storyFeeds = $( '.story-feed' ).map( ( i, el ) => $( el ) ); /* 1 */



  function init( $el ) {

    const $sliderContainer = $el.find( '.story-feed__slider' );
  


    $sliderContainer.slick( {
      labelPrevArrow: 'Previous Story',
      labelNextArrow: 'Next Story',
      slidesToShow: 4,
      responsive: [ {
        breakpoint: BREAKPOINT_LG,
        settings: {
          slidesToShow: 3
        }
      },{
        breakpoint: BREAKPOINT_MD,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: BREAKPOINT_SM,
        settings: {
          slidesToShow: 1
        }
      } ]
    } );

  }



  // Setup Story Feed sliders.
  if ( !$storyFeeds.length ) {
    return;
  }

  import( 'accessible_slick_script' )
    .then( ( res ) => {

      MediaQuery._init();
      $storyFeeds.map( ( i, $el ) => init( $el ) );

    } )
    .catch( ( e ) => console.log( e ) );

}



StoryFeedSlider();
